import { useAuth } from './useAuth';

/**
 * Returns `true` when the current user is in read-only (viewer) mode.
 *
 * While auth is still loading (user not yet hydrated), returns `true` to
 * keep write actions disabled during the brief loading window.
 *
 * **When to use this vs `<ViewerGuardedButton>`:**
 *
 * - Use `useWriteGuard()` when you need to guard **non-button** UI such as
 *   text inputs, layout changes, conditional columns, or hiding entire
 *   sections.
 * - Use `<ViewerGuardedButton>` (which calls this hook internally) as a
 *   drop-in replacement for `<Button>` when the only guard needed is
 *   disabling a submit / action button.
 *
 * Server-side enforcement exists in both the actions-api preHandler and the
 * PostgREST `set_user_context()` guard; these UI guards are defence-in-depth.
 */
export const useWriteGuard = (): boolean => {
  const { isViewer, isLoading } = useAuth();
  // Guard-active while auth is loading to prevent writes during hydration.
  return isLoading || isViewer;
};
